/* eslint-disable */

function loadScripts() {

}

export default loadScripts;
